<template>
    <div class="sidebar">
        <div @click='closeMenu' :class='{"sidebar-mask":collapse}'></div>
		<!--:background-color="themeColor"-->
        <el-menu
            class="sidebar-el-menu"
            :default-active="onRoutes"
            :collapse="!collapse"
            text-color="#000000"
            background-color="#ffffff"
            active-text-color="#b8bbbb"
            unique-opened
            router
        >
            <template v-for="item in menuList">
                <template v-if="item.children.length > 0">
                    <el-submenu :index="item.id" :key="item.id">
                        <!--二级菜单-->
                        <template slot="title">
                            <i :class="item.menuIcon"></i>
                            <span slot="title" class="menu-style">{{ item.menuName }}</span>
                        </template>
                        <template v-for="subItem in item.children">
                            <template v-if="subItem.menuType === 1">
                                <el-submenu :index='subItem.id' :key="subItem.id">
                                    <template slot="title">
                                        <i :class="subItem.menuIcon"></i>
                                        <span slot="title" class="menu-style">{{ subItem.menuName }}</span>
                                    </template>
                                    <template v-for='(subItems,index) in subItem.children'>
                                        <el-menu-item :index="subItems.menuLink" :key="subItems.id" @click='closeMenu'>
                                            <i :class="subItems.menuIcon"></i>
                                            <span class="menu-style">{{ subItems.menuName }}</span>
                                        </el-menu-item>
                                    </template>
                                </el-submenu>
                            </template>
                            <template v-else>
                                <el-menu-item :index="subItem.menuLink" :key="subItem.id" @click='closeMenu'>
                                    <i :class="subItem.menuIcon"></i>
                                    <span class="menu-style">{{ subItem.menuName }}</span>
                                </el-menu-item>
                            </template>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
					<el-submenu :index="item.menuLink" :key="item.id">
						<template slot="title">
							<i :class="item.menuIcon"></i>
							<span slot="title">{{ item.menuName }}</span>
						</template>
					</el-submenu>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
import bus from '../common/bus';
import { mapState } from 'vuex';
import { Settings, Home, Users, FileText } from '@v2icons/tabler';
import fa from 'element-ui/src/locale/lang/fa';

export default {
    components: {
        Settings,
        Home,
        Users,
        FileText
    },
    data() {
        return {
            collapse: false
        };
    },
    computed: {
        fa() {
            return fa
        },
        ...mapState(['menuList', 'themeColor']),
        onRoutes() {
            return this.$route.path;
        }
    },
    created() {
        console.log(this.menuList);
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', (msg) => {
            console.log('collapse',msg)
            this.collapse = msg;
            bus.$emit('collapse-content', msg);
        });
    },
    methods:{
        closeMenu(){
            bus.$emit('header-btn')
        }
    }
};
</script>

<style scoped>

.el-submenu__title i,
.el-menu-item i {
    color: inherit !important;
	font-size:14px;
}

.el-submenu__title span,
.el-menu-item span {
    color: inherit !important;
	height:40px;
	line-height: 40px;
}
.sidebar {
    display: block;
    position: absolute;
    left: 100px;
    top: 0px;
    bottom: 0;
    overflow-y: scroll;
    background-color: #fff;
    display: none;
}
.sidebar::-webkit-scrollbar {
    width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
    width: 200px;

}
.sidebar > ul {
    height: 100%;
}
.menu-style{
	font-size:13px;
}

::v-deep .el-submenu .el-menu-item{
	height:40px;
	line-height:40px;
	min-width:199px;
}

.el-menu--collapse{
    width: 0 !important;
}

@media screen and (max-width: 1000px){
    .sidebar{
        display: block;
        left: 0;
    }
    .sidebar-mask{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        background-color: rgba(0,0,0,0.3);
        z-index: 11;
    }
    .sidebar-el-menu{
        z-index: 12;
    }
}

</style>
